"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const provider_1 = require("../provider");
class ConditionField {
    constructor(field) {
        this.field = field;
    }
    getValidator() {
        if (!provider_1.validators[this.field])
            throw new Error(`Missing validator for field ${this.field}`);
        return provider_1.validators[this.field];
    }
    getExtraFieldValidator() {
        if (!provider_1.extraFieldsValidators[this.field])
            throw new Error(`Missing validator for extra field ${this.field}`);
        return provider_1.extraFieldsValidators[this.field];
    }
    static build(field) {
        return new ConditionField(field.field); // Maybe validate here?
    }
}
exports.default = ConditionField;
